import CardIcon from '@shared/components/core/card/CardIcon';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgMemberCardProps {
    orgId: string;
}

export default function OrgMemberCard({ orgId }: IOrgMemberCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardIcon
            name="orgMembers"
            title={t('common:organization.member.viewAll.title')}
            description={t('common:organization.member.viewAll.description')}>
            <OrgLinks organizationId={orgId} variant={'orgMembers'} />
        </CardIcon>
    );
}
